// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AdminGetSiteAccountsDefaultResponse {
    static getAttributeTypeMap() {
        return AdminGetSiteAccountsDefaultResponse.attributeTypeMap;
    }
}
AdminGetSiteAccountsDefaultResponse.discriminator = undefined;
AdminGetSiteAccountsDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "GetSiteAccountsResponseModel"
    }
];
//# sourceMappingURL=adminGetSiteAccountsDefaultResponse.js.map